<template>
  <div>
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn :color="buttonColor" elevation="0" v-bind="attrs" v-on="on">
          <v-icon class="mr-2">mdi-tooth</v-icon>
          {{ toTitleCase(selectedOrderSession.dentate) }}
          <v-icon v-if="selectedOrder.dentates.length > 1" class="ml-2">
            mdi-chevron-down
          </v-icon>
        </v-btn>
      </template>
      <v-list dense>
        <v-subheader>CASE DENTATES</v-subheader>
        <v-divider />
        <v-sheet v-for="(dentate, index) in orderDentates" :key="index">
          <v-list-item two-line @click="changeDentate(dentate)">
            <v-list-item-icon class="mt-4">
              <v-icon v-if="selectedOrderSession.dentate !== dentate">
                mdi-tooth
              </v-icon>
              <v-icon v-else> mdi-check </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ toTitleCase(dentate) }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider />
        </v-sheet>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import { toTitleCase } from "@/utils"

export default {
  name: "SessionSwitcher",

  props: ["color"],

  data() {
    return {
      loading: false,
      newSession: false,
      newSessionType: "",
      rule: [(v) => !!v || "Required"]
    }
  },

  computed: {
    ...mapGetters(["selectedOrder", "selectedOrderSession", "currentPlan"]),

    orderDentates() {
      return this.selectedOrder.dentates
    },

    buttonColor() {
      if (this.color) return this.color
      return "primary"
    },

    sortedOrderSessions() {
      const sessions = [...this.selectedOrder.sessions].sort((a, b) =>
        b.created_at.localeCompare(a.created_at)
      )
      return sessions
    }
  },

  methods: {
    ...mapActions([
      "setSelectedOrderSession",
      "setSelectedForwardedOrder",
      "triggerReload"
    ]),

    toTitleCase,

    changeDentate(dentate) {
      if (dentate === this.selectedOrderSession.dentate) return
      const sessions = [...this.selectedOrder.sessions]
        .filter((s) => s.dentate === dentate)
        .sort((a, b) => b.created_at.localeCompare(a.created_at))

      this.setSelectedOrderSession(sessions[0])
      this.setSelectedForwardedOrder(null)
      this.triggerReload("forwardedOrders")
      this.triggerReload("files")
      this.triggerReload("exports")
      if (this.$route.query.tab !== "overview")
        this.$router.push({ query: { tab: "overview" } })
    }
  }
}
</script>
